import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user_id: 0,
  acc_id: 0,
  name: '',
  users: [],
  is_logout: false,
  current_user: null,
  from_client: false
};


export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setAccId: (state, action) => {
      state.acc_id = action.payload;
    },
    setUserId: (state, action) => {
      state.user_id = action.payload;
    },
    setName: (state, action) => {
      state.name = action.payload;
    },
    setUsers: (state, action) => {
      state.users = action.payload;
    },
    setIsLogOut: (state, action) => {
      state.is_logout = action.payload;
    },
    setCurrentUser: (state, action) => {
      state.current_user = action.payload;
    },
    setFromClient: (state, action) => {
      state.from_client = action.payload;
    },
  },
});

export const {setAccId, setUserId, setName, setUsers, setIsLogOut, setCurrentUser, setFromClient } = loginSlice.actions;

export const selectUserId = (state) => state.login.user_id;
export const selectName = (state) => state.login.name;
export const selectUsers = (state) => state.login.users;
export const selectIsLogOut = (state) => state.login.is_logout;
export const selectCurrentUser = (state) => state.login.current_user;
export const selectFromClient = (state) => state.login.from_client;
export const selectAccId = (state) => state.login.acc_id;


export default loginSlice.reducer;
